import { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Expand } from "lucide-react";
import { GALLERY_CATEGORIES } from "../../content/site";
import { useGallery } from "../../hooks/useSiteData";
import { SectionHeading, Reveal } from "./Motion";
import { Lightbox } from "./Lightbox";

export const Portfolio = () => {
  const all = useGallery();
  const [filter, setFilter] = useState("all");
  const [index, setIndex] = useState(null);
  const items = useMemo(() => (filter === "all" ? all : all.filter((i) => i.category === filter)), [all, filter]);

  return (
    <section id="portfolio" className="relative bg-cream-deep section-pad" data-testid="portfolio-section">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading eyebrow="Portfolio" title="Moments," script="frame by frame" testid="portfolio-heading" />
          <Reveal className="flex flex-wrap gap-2" >
            {GALLERY_CATEGORIES.map((c) => (
              <button
                key={c.id}
                onClick={() => setFilter(c.id)}
                className={`rounded-full border px-5 py-2.5 text-[13px] transition-colors duration-300 ${
                  filter === c.id ? "border-gold bg-gold text-cream" : "border-gold/30 bg-white/70 text-ink hover:border-gold"
                }`}
                data-testid={`portfolio-filter-${c.id}`}
              >
                {c.label}
              </button>
            ))}
          </Reveal>
        </div>
        <motion.div layout className="mt-14 columns-2 gap-3 sm:gap-5 md:columns-3 xl:columns-4" data-testid="portfolio-grid">
          <AnimatePresence>
            {items.map((item, i) => (
              <motion.button
                layout
                key={item.id}
                initial={{ opacity: 0, scale: 0.94 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.94 }}
                transition={{ duration: 0.5 }}
                onClick={() => setIndex(i)}
                className="group relative mb-3 block w-full break-inside-avoid overflow-hidden rounded-2xl sm:mb-5"
                data-testid={`portfolio-item-${item.id}`}
              >
                <img src={item.src} alt={item.caption || "Wedding photo"} loading="lazy" className="w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110" />
                <div className="absolute inset-0 flex items-end justify-between bg-gradient-to-t from-black/55 via-transparent to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="font-serif text-lg italic text-white">{item.caption}</span>
                  <Expand className="h-4 w-4 text-white" />
                </div>
              </motion.button>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
      <Lightbox items={items} index={index} onClose={() => setIndex(null)} onIndex={setIndex} />
    </section>
  );
};
